import { render, staticRenderFns } from "./RejeicaoDocumento.vue?vue&type=template&id=5a339c1b"
import script from "./RejeicaoDocumento.vue?vue&type=script&lang=js"
export * from "./RejeicaoDocumento.vue?vue&type=script&lang=js"
import style0 from "./RejeicaoDocumento.vue?vue&type=style&index=0&id=5a339c1b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports